<template>
  <span v-if="workingQualifier">
      <v-row class="mt-6">
        <v-col cols="12">
          <v-text-field
            label="Minimum Balance"
            v-model="workingQualifier.minimumBalanceAmount"
            type="number"
            hint="Ex. 5.00"
            prefix="$"
            hide-spin-buttons
            dense
            :rules="requiredAndPositiveRule"
            @change="onChange"
            name="minimumBalanceAmount"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select label="Balance Type" outlined dense :items="Object.entries(BalanceTypes)" v-model="workingQualifier.balanceType" item-text="1" item-value="0" :rules="requiredRule" @change="onChange" ref="balanceType"/>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-select label="Calculation Method" outlined dense :items="Object.entries(MinBalanceCalculationMethods)" v-model="workingQualifier.calculationMethod" item-text="1" item-value="0" :rules="requiredRule" @change="onChange" ref="calculationType"/>
        </v-col>
      </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { MinimumBalanceQualifier } from '@/api/product/levelrewards/qualifiers';
import { BalanceTypes, MinBalanceCalculationMethods } from '@/api/product/levelrewards/';
import { ValidationTool } from '@/util';

@Component
export default class MinimumBalanceQualifierEditor extends Vue {
  @Prop()
  value!:MinimumBalanceQualifier;

  workingQualifier:MinimumBalanceQualifier | null = null;

  // Make visible to template
  BalanceTypes:any = BalanceTypes;

  MinBalanceCalculationMethods:any = MinBalanceCalculationMethods;

  requiredRule:Array<any> = [(value: any) => {
    if (!value || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingQualifier = this.value.clone() as MinimumBalanceQualifier;
  }

  onChange() {
    this.$emit('input', this.workingQualifier);
  }
}
</script>

<style lang="scss" scoped>
</style>
